import { format, parseISO } from "date-fns";
import { nb } from "date-fns/locale";
import { Link } from "react-router-dom";

import { faPencil, faPlusCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Direction, Flex } from "@ntemarked/mittne-components/dist/Flex/Flex";

import { TrafficLightBadge } from "components/atoms/Badge";
import Error from "components/molecules/Error";
import Loading from "components/molecules/Loading";
import { MainLayoutPageHeader } from "components/organisms/MainLayout";
import { Table } from "components/organisms/Table";
import { InfoTextDetailsFragment, useAllInfoTextsQuery } from "pages/Content/InfoTextPages/InfoTextPages.graphql-gen";

export default function InfoTextListPage() {
	const { data, error, loading } = useAllInfoTextsQuery();

	return (
		<>
			<MainLayoutPageHeader
				title={
					<Flex gap="var(--grid-2)">
						Tekstsider
						<Link to="create" title="Ny infotekst">
							<FontAwesomeIcon icon={faPlusCircle} />
						</Link>
					</Flex>
				}
			/>
			<Flex style={{ marginTop: "40px", borderRadius: "15px", overflow: "hidden" }} direction={Direction.column}>
				{error && !loading && <Error errorMessage="Feil ved henting av data" />}
				{loading && !data && <Loading />}
				<Table
					entries={data?.allInfoTexts}
					labels={{ active: "Aktiv", key: "Nøkkel", title: "Tittel", lastUpdated: "Sist oppdatert" }}
					generators={{
						title: (i: InfoTextDetailsFragment) => (
							<Link to={`/info-text/${i.id}`} title="Se eller endre infotekst">
								{i.title}
							</Link>
						),
						active: (i: InfoTextDetailsFragment) => (
							<TrafficLightBadge green={i?.active} red={!i?.active}>
								<>{i?.active ? "Aktiv" : "Ikke aktiv"}</>
							</TrafficLightBadge>
						),
						lastUpdated: (i: InfoTextDetailsFragment) => (
							<p>
								{format(parseISO(i.lastUpdated || ""), "dd.MM.yy HH:mm", {
									locale: nb,
								})}
							</p>
						),
					}}
					action={(i: InfoTextDetailsFragment) => (
						<Link to={`/info-text/${i.id}`} title="Se eller endre infotekst">
							<FontAwesomeIcon icon={faPencil} />
						</Link>
					)}
				/>
			</Flex>
		</>
	);
}
